import * as React from 'react';
import { useSelector } from 'react-redux';

import * as style from './index.css';
import { addAdFoxBanner } from '../';
import { IAppState } from '../../../../common/state';
import { newbuildingTestCtrParallaxInTgbFooterExpGroupSelector } from '../../../../selectors/dealSaleBanner/newbuildingTestCtrParallaxInTgbFooterExpGroupSelector';
import { selectResultPuids } from '../../../../selectors/results/selectResultPuids';
import { selectLocationIdForAdfox } from '../../../../selectors/selectLocationIdForAdfox';
import { selectIsAgent } from '../../../../selectors/user';
import { useApplicationContext } from '../../../../utils/applicationContext';
import { EAdFoxBannerTypes } from '../templates';

/**
 * @todo Удалить функцию с экспериментом
 * @description Данный функционал появился в задаче CD-200669, будет удалён в задаче CD-200835
 * Если группа эксперимента A победит, то оставить, но переименовать в SeoTopBanners и удалить комментарий
 * Если группа A не победит, тогда удалить функцию целиком
 */
const SeoTopBannersA: React.FC = () => {
  const puids = useSelector(selectResultPuids);
  const isAgent = useSelector(selectIsAgent);
  const makeRequest = useSelector((state: IAppState) => state.makeRequest);

  const banners = [1, 2, 3].map(id => {
    return addAdFoxBanner({
      type: EAdFoxBannerTypes.seoNew,
      key: `tgb_in_seo-${id}`,
      makeRequest,
      puids,
      isAgent,
      isNew: true,
      width: '100%',
      minHeight: '200px',
      postViewAnalyticsData: {
        banner: {
          place: 'offersSerp',
          name: 'Listing_footer_TGB',
          position: id,
          extra: {
            offerType: 'TGB_banner',
          },
        },
      },
    });
  });

  return <div className={style['container']}>{banners}</div>;
};

/**
 * @todo Удалить функцию с экспериментом
 * @description Данный функционал появился в задаче CD-200669, будет удалён в задаче CD-200835
 * Если группа эксперимента B победит, то оставить, но переименовать в SeoTopBanners и удалить комментарий
 * Если группа B не победит, тогда удалить функцию целиком
 */
export const SeoTopBannersB: React.FC = () => {
  const puids = useSelector(selectResultPuids);
  const locationId = useSelector(selectLocationIdForAdfox);
  const isAgent = useSelector(selectIsAgent);
  const makeRequest = useSelector((state: IAppState) => state.makeRequest);

  return (
    <div
      /**
       * @todo Переименовать селектор с экспериментом
       * @description Данный функционал появился в задаче CD-200669, будет удалён в задаче CD-200835
       * Переименовать в container, подчистить ненужный мусор из css
       */
      className={style['container-b']}
    >
      {addAdFoxBanner({
        type: 'parallax_footer',
        key: 'parallax_in_seo',
        makeRequest,
        puids,
        locationId,
        isAgent,
        isNew: true,
        width: '100%',
        minHeight: '395px',
      })}
    </div>
  );
};

/**
 * @todo Удалить функцию с экспериментом
 * @description Данный функционал появился в задаче CD-200669, будет удалён в задаче CD-200835
 * Если группа эксперимента C победит, то оставить, но переименовать в SeoTopBanners и удалить комментарий
 * Если группа C не победит, тогда удалить функцию целиком
 */
const SeoTopBannersC: React.FC = () => {
  const puids = useSelector(selectResultPuids);
  const locationId = useSelector(selectLocationIdForAdfox);
  const isAgent = useSelector(selectIsAgent);
  const makeRequest = useSelector((state: IAppState) => state.makeRequest);

  return (
    <div
      /**
       * @todo Переименовать селектор с экспериментом
       * @description Данный функционал появился в задаче CD-200669, будет удалён в задаче CD-200835
       * Переименовать в container, подчистить ненужный мусор из css
       */
      className={style['container-c']}
    >
      {addAdFoxBanner({
        type: 'stretch_banner',
        key: 'stretch_in_seo',
        makeRequest,
        puids,
        locationId,
        isAgent,
        isNew: true,
        width: '100%',
        minHeight: '200px',
      })}
    </div>
  );
};

/**
 * @todo Удалить функцию с экспериментом
 * @description Данный функционал появился в задаче CD-200669, будет удалён в задаче CD-200835
 * Удалить в любом случае
 */
export const SeoTopBanners: React.FC = () => {
  const subdomain = useSelector((state: IAppState) => state.currentSubdomain);
  const { config } = useApplicationContext();

  const newbuildingTestCtrParallaxInTgbFooterExpGroup = useSelector(
    newbuildingTestCtrParallaxInTgbFooterExpGroupSelector,
  );

  /**
   * @todo Удалить строку с экспериментом
   * @description Данный функционал появился в задаче CD-200669, будет удалён в задаче CD-200835
   * Не забудь забудь удалить из src/node/config.json и src/node/scheme.json
   */
  const newbuildingTestCtrParallaxInTgbFooterEnabled = config.get('Newbuilding.TestCtrParallaxInTgbFooter.Enabled');

  if (
    newbuildingTestCtrParallaxInTgbFooterEnabled &&
    subdomain === 'spb' &&
    newbuildingTestCtrParallaxInTgbFooterExpGroup === 'B'
  ) {
    return <SeoTopBannersB />;
  }

  if (
    newbuildingTestCtrParallaxInTgbFooterEnabled &&
    subdomain === 'spb' &&
    newbuildingTestCtrParallaxInTgbFooterExpGroup === 'C'
  ) {
    return <SeoTopBannersC />;
  }

  return <SeoTopBannersA />;
};
